export default "__VITE_ASSET__B6sgy7QH__"